import configHM from '@/api/HardwareApi/HM/config';
import { getAuthority } from '@/auth/authority';
import Auths from '@/auth/Auths';
// eslint-disable-next-line import/no-cycle
import { decrypt } from '@/tool/crypto';

import { parseToken } from './jwt';

export function getProfile() {
  const profile = localStorage.getItem('profile');
  return profile ? JSON.parse(profile) : {};
}

export function setProfile(profile) {
  localStorage.setItem('profile', JSON.stringify(profile));
}

export function setToken(token) {
  localStorage.setItem('token', token);
}

export function getToken() {
  return localStorage.getItem('token');
}

export function removeToken() {
  localStorage.removeItem('token');
}

export function getConfig() {
  const config = localStorage.getItem('config');
  return config ? JSON.parse(config) : {};
}

export function setConfig(config) {
  localStorage.setItem('config', JSON.stringify(config));
}

export function setSystemCode(sysCode, regCode) {
  // 只穿过来一个系统码，代表这是WM SDK
  if (sysCode && !regCode) {
    localStorage.setItem('code', sysCode);
  } else {
    // 其他情况未考虑，默认为HM SDK
    localStorage.setItem('code', `${sysCode},${regCode}`);
  }
}

export function getSystemCode() {
  //  2024-03-11  LQ  返回的系统码改成了加密串，需要先进行解密。
  const sysCode = decrypt(localStorage.getItem('code'));
  if (isWMSdk()) {
    // TODO: 后台更新完毕后，使用真实返回的秘钥
    // return "00000000000000000000" || localStorage.getItem('code');
    // return localStorage.getItem('code');
    return sysCode;
  }
  const [syscode, regcode] = (sysCode || '').split(',');
  return {
    syscode: syscode || configHM.sysCode,
    regcode: regcode || configHM.regCode,
  };
}

export function getDistlic() {
  const encryptedDistlicInToken = parseToken(getToken())?.payload?.distlic;
  return encryptedDistlicInToken ? decrypt(encryptedDistlicInToken) : '';
}

export function isTrialVersion() {
  //  2024-03-11  LQ  试用状态直接由后台个人信息中返回。
  return getProfile().trialVersion;
  // const code = getSystemCode();
  // // console.warn('code', code);
  // if (isWMSdk()) {
  // 	return code == configWM.secret;
  // }
  // const { syscode, regcode } = code;
  // return syscode == configHM.sysCode && regcode == configHM.regCode;
}

export function getWillExpireDays() {
  // eslint-disable-next-line no-unused-vars
  const [days, millseconds] = getProfile().expiredin || [];
  return days;
}

export function setStoredLicenseRequestCode(code) {
  localStorage.setItem('license_request_code', code);
}

export function getStoredLicenseRequestCode() {
  return localStorage.getItem('license_request_code');
}

export function removeStoredLicenseRequestCode() {
  localStorage.removeItem('license_request_code');
}

export function setStoredEditionRequestCode(code) {
  localStorage.setItem('edition_request_code', code);
}

export function getStoredEditionRequestCode() {
  return localStorage.getItem('edition_request_code');
}

export function removeStoredEditionRequestCode() {
  localStorage.removeItem('edition_request_code');
}

export function isWMSdk() {
  return !!getProfile().wmSdk;
}

export function isGuest() {
  return getAuthority().includes(Auths.GUEST);
}

export function isLicensable() {
  return getProfile().licensable;
}

export function isWMAdvancedUnlock() {
  return isWMSdk() && getProfile().advanced?.unlock_mode;
}

export function isAdvancedTask() {
  return getProfile().advanced?.task;
}

export function getCryptoType() {
  // 0： 明文
  // 1： AES加密
  // 2： 摘要验证
  return Number(localStorage.getItem('crypto')) || 0;
}

export function setCryptoType(type) {
  localStorage.setItem('crypto', type);
}

export function setCryptoKey(key) {
  localStorage.setItem('cryptoKey', key);
}

export function getCryptoKey() {
  return localStorage.getItem('cryptoKey') || '';
}

export function setEmergency(emergency) {
  setProfile({
    ...getProfile(),
    emergency,
  });
}

export function setCaptcha(captcha) {
  localStorage.setItem('captcha', captcha);
}

export function getCaptcha() {
  return JSON.parse(localStorage.getItem('captcha')) || false;
}

// 设置多企业标记
export function setMulti(multi) {
  localStorage.setItem('multi', multi);
}

// 获取是否多企业标记
export function isMulti() {
  const multi = localStorage.getItem('multi');
  return JSON.parse(multi) || false;
}

export function setReportMailSupport(support) {
  localStorage.setItem('reportMail', support);
}

export function getReportMailSupport() {
  return JSON.parse(localStorage.getItem('reportMail')) || false;
}

export function setRecentMails(mails) {
  const recentMails = getRecentMails();
  mails.forEach(mail => {
    const index = recentMails.indexOf(mail);
    if (index > -1) {
      recentMails.splice(index, 1);
    }
    recentMails.unshift(mail);
  });
  localStorage.setItem('mails', JSON.stringify(recentMails.slice(0, 10)));
}

export function getRecentMails() {
  const recentMails = localStorage.getItem('mails');
  return recentMails ? JSON.parse(recentMails).slice(0, 5) : [];
}

export function isELC() {
  return getProfile().advanced?.elc;
}

export function getElctype() {
  return getProfile().advanced?.elc_type || 0;
}

export function isKeycabinet() {
  return getProfile().keycabinet;
}

export function isLocationSwitch() {
  return getProfile().locationswitch;
}

export function isLite() {
  return getProfile().lite;
}

// 设置网站标题
export function setSiteTitle(title) {
  localStorage.setItem('siteTitle', title);
}

// 获取网站标题
export function getSiteTitle() {
  return localStorage.getItem('siteTitle') || '';
}
